import { Component, OnInit, Compiler } from '@angular/core';
import { DadosAcessoService } from '../../../dadosAcesso.service'
import { AcessoApiService} from '../../../acessoApi.service'
import {ɵBROWSER_SANITIZATION_PROVIDERS, DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css']
})
export class NoticiasComponent implements OnInit {
  public mostrarEditar: boolean
public manchete1: string 
public manchete2: string 
public manchete3: string 
public manchete4: string 
public url1: string 
public url2: string 
public url3: string 
public url4: string 
public imagem1: string
public imagem2: string
public imagem3: string
public imagem4: string

  constructor(private dadosAcesso: DadosAcessoService, private acessoAPI:AcessoApiService, private sanitizer: DomSanitizer, private compiler: Compiler) {
    this.compiler.clearCache();
    if(sessionStorage.getItem('ExibirBotaoEditar') === 'true'){
      this.mostrarEditar = true
    }
    else{
      this.mostrarEditar = false
    }
    acessoAPI.getFeed().subscribe(data=>{
      this.manchete1 = data[0].MANCHETE_FEED;
      this.manchete2 = data[1].MANCHETE_FEED;
      this.manchete3 = data[2].MANCHETE_FEED;
      this.manchete4 = data[3].MANCHETE_FEED;

      this.url1 = data[0].URL_FEED;
      this.url2 = data[1].URL_FEED;
      this.url3 = data[2].URL_FEED;
      this.url4 = data[3].URL_FEED;

    })

    this.acessoAPI.recuperarImagens().subscribe(data =>{
      
      this.imagem1 = "http://site.masterretail.com.br/Files/" + data[0].OriginalPath
    this.compiler.clearCache();
      
      this.imagem2 = "http://site.masterretail.com.br/Files/" + data[1].OriginalPath
    this.compiler.clearCache();
      
      this.imagem3 = "http://site.masterretail.com.br/Files/" + data[2].OriginalPath
    this.compiler.clearCache();
      
      this.imagem4 = "http://site.masterretail.com.br/Files/" + data[3].OriginalPath
    this.compiler.clearCache();
      
      
    })


   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/noticias/noticias.component.ts